import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import EventBus from "../../util/EventBus";
import MemoryContext from "../../util/MemoryContext";

export default function Logout() {

    const navigate = useNavigate();

    useEffect(() => {

        sessionStorage.clear();

        MemoryContext.components = {}

        // @ts-ignore
        EventBus.session.emit("update");

        navigate("/", {replace: true});

    }, [navigate]);

    return null;
}
